import { createFileRoute } from "@tanstack/react-router";
import { OrderDetailContainer } from "@/features/orders";

export const Route = createFileRoute("/$store/_layout/orders_/$orderId")({
	component: OrderDetailPage,
});

function OrderDetailPage() {
	const { store, orderId } = Route.useParams();
	return <OrderDetailContainer store={store} orderId={orderId} />;
}
